export const notificationsList = [
  // GLOBAL
  'global',

  // NEWS
  // 'newsletters'
  'inventories_activity_summary',

  // NETWORK
  'friend_accepted_request',
  'friendship_request',
  'group_invite',
  'group_acceptRequest',
  'group_join_request',

  // TRANSACTIONS
  'your_item_was_requested',
  'update_on_your_item',
  'update_on_item_you_requested',
] as const
